<template>
    <div>
        {{ errorMessage }}
    </div>
</template>

<script>
    export default {
        props: {
            errorMessage: {
                type: String,
                default: 'Forbidden'
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/ErrorPage.vue